import React , { useState } from "react";
import { ArrowDownIcon, ArrowIcon } from "./ArrowIcon";
import i18next from 'i18next';

export const Skills = () => {

    const [showText, setShowText] = useState(false);

    const handleArrowClick = (id) => {

        const element = document.getElementById(id);
        
        if (element) {
            setShowText(!showText);
            if (showText) {
                element.style.display = "none";
            } else {
                element.style.display = "block";
            }
        }
    };

    return (
        <>
            <div className="page-content text-center d-flex align-items-center flex-column text-white">
                <h1 className="section-title">
                    {i18next.t('softSkills')}
                </h1>
                <div className="section-content flex-column gap-2 mt-3" id="skillsContent">
                   <div className="soft-content">
                        <div className="soft-head" onClick={() => handleArrowClick("comunicationDesc")}>
                            <h3 className="soft-title">
                                {i18next.t('comunication')}
                            </h3>
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />}
                        </div>
                        <p className="soft-text" id="comunicationDesc">
                            {i18next.t('comunicationDescription')}
                        </p>
                    </div>
                    <div className="soft-content">
                        <div className="soft-head" onClick={() => handleArrowClick("empathyDesc")}>
                            <h3 className="soft-title">
                                {i18next.t('empathy')}
                            </h3>
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />}               
                        </div>
                        <p className="soft-text" id="empathyDesc">
                            {i18next.t('empathyDescription')}
                        </p>
                    </div>
                    <div className="soft-content">
                        <div className="soft-head" onClick={() => handleArrowClick("adaptabilityDesc")}>
                            <h3 className="soft-title">
                                {i18next.t('adaptability')}
                            </h3>
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />}               
                        </div>
                        <p className="soft-text" id="adaptabilityDesc">
                            {i18next.t('adaptabilityDescription')}
                        </p>
                    </div>
                    <div className="soft-content">
                        <div className="soft-head" onClick={() => handleArrowClick("solvingDesc")}>
                            <h3 className="soft-title">
                                {i18next.t('problemSolving')}
                            </h3>
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />} 
                        </div>
                        <p className="soft-text" id="solvingDesc">
                            {i18next.t('problemSolvingDescription')}
                        </p>
                    </div>
                    <div className="soft-content">
                        <div className="soft-head" onClick={() => handleArrowClick("teamworkDesc")}>
                            <h3 className="soft-title">
                                {i18next.t('teamwork')}
                            </h3>
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />}
                        </div>
                        <p className="soft-text" id="teamworkDesc">
                            {i18next.t('teamworkDescription')}
                        </p>
                    </div>
                    <div className="soft-content">
                        <div className="soft-head" onClick={() => handleArrowClick("organizationDesc")}>
                            <h3 className="soft-title">
                                {i18next.t('organization')}
                            </h3>
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />}                
                        </div>
                        <p className="soft-text" id="organizationDesc">
                            {i18next.t('organizationDescription')}
                        </p>
                    </div>
                    <div className="soft-content">
                        <div className="soft-head" onClick={() => handleArrowClick("thinkingDesc")}>
                            <h3 className="soft-title">
                                {i18next.t('criticalThinking')}
                            </h3>
                            {window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon />}               
                        </div>
                        <p className="soft-text" id="thinkingDesc">
                            {i18next.t('criticalThinkingDescription')}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};
